import { Dispatch, SetStateAction } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { CompanyDto } from 'tdc-web-backend/companies/schemas';
import { EnumCountry, mapCountry } from 'tdc-web-backend/enums/enums';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../../../../../../../../../components/confirm-modal/ConfirmModal';
import { ReactComponent as SuitcaseCheckIcon } from '../../../../../../../../../../assets/icons/layout-icons/SuitcaseCheckIcon.svg';
import { primaryLight } from '../../../../../../../../../../utils/color';
import CustomInput from '../../../../../../../../../../components/custom-input/CustomInput';
import { useRefresh } from '../../../../../../../../../../utils/hooks/crud-hooks/useRefresh';
import useUserCompany from '../../../../../../../../../../utils/hooks/useUserCompany';

interface CompanyTargetMarketsEditModalProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyTargetMarketsEditModal = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyTargetMarketsEditModalProps) => {
  const { company: companyData, updateCompany, isLoadingUpdateCompany } = useUserCompany();
  const refresh = useRefresh();
  const { t } = useTranslation();
  const methods = useForm<Pick<CompanyDto, 'targetCountries'>>({
    mode: 'onChange',
    defaultValues: {
      targetCountries: companyData?.targetCountries ?? ([] as EnumCountry[]),
    },
  });

  const onSubmit = (data: Pick<CompanyDto, 'targetCountries'>) => {
    updateCompany(data, {
      onSuccess: () => {
        refresh();
        setIsEditModalOpen(false);
      },
    });
  };

  return (
    <ConfirmModal
      width="40%"
      confirmButtonText={t('common.save')}
      title={t('settings.companyProfile.targetMarkets')}
      isModalOpen={isEditModalOpen}
      setIsModalOpen={setIsEditModalOpen}
      onCancel={() => setIsEditModalOpen(false)}
      automaticallyCloseModalOnButtonClick={false}
      isLoading={isLoadingUpdateCompany}
      onConfirm={methods.handleSubmit(onSubmit)}
      iconProps={{
        icon: <SuitcaseCheckIcon fill={primaryLight[500]} />,
        wrapperBackgroundColor: '#E3DBFC',
      }}
      message={
        <FormProvider {...methods}>
          <Box component="form">
            <CustomInput
              required
              input={<CustomInput.Autocomplete />}
              choices={mapCountry}
              translation={{ t, ns: 'enum' }}
              name="targetCountries"
              label={t('settings.companyProfile.targetMarkets')}
              multiple
              placeholder={t('common.select')}
              sx={{ width: '100%' }}
            />
          </Box>
        </FormProvider>
      }
    />
  );
};
export default CompanyTargetMarketsEditModal;
